import { lazy } from "react";

// project imports
import Loadable from "../components/molecules/Berry/Loadable";
import DetailyGuard from "../components/atoms/route-guard/DetailyGuard";
import { Outlet } from "react-router-dom";

// dashboard routing
const KatalogDetailov = Loadable(
  lazy(() => import("../components/pages/KATALOG_DETAILOV_ARCH_FOR_OBS"))
);
const NotAllowedPage = Loadable(
  lazy(() => import("../components/pages/notAllowedPage"))
);
const Error = Loadable(lazy(() => import("../components/pages/errorPage")));
// ==============================|| MAIN ROUTING ||============================== //

const DetailyRoutes = {
  path: "/",
  element: (
    <DetailyGuard>
      <Outlet />
    </DetailyGuard>
  ),
  children: [
    {
      path: "/app/katalog-detailov",
      element: <KatalogDetailov />,
    },
    {
      path: "/app/not-allowed",
      element: <NotAllowedPage />,
    },
    {
      path: "/app/error",
      element: <Error />,
    },
    {
      path: "*",
      element: <Error />,
    },
  ],
};

export default DetailyRoutes;
